import { render, staticRenderFns } from "./retouches.vue?vue&type=template&id=69270212&scoped=true"
import script from "./retouches.vue?vue&type=script&lang=js"
export * from "./retouches.vue?vue&type=script&lang=js"
import style0 from "./retouches.vue?vue&type=style&index=0&id=69270212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69270212",
  null
  
)

export default component.exports